import type { ReactNode } from "react";
import { ExternalLinkContainer } from "../ExternalLinkContainer";

export interface DisruptionExerciseTermsLinkProps {
  children?: ReactNode;
  linkUrl: string;
  displayInModal: boolean;
}

export const DisruptionExerciseTermsLink = ({
  children,
  linkUrl,
  displayInModal,
}: DisruptionExerciseTermsLinkProps) => (
  <ExternalLinkContainer
    linkUrl={linkUrl}
    displayInModal={displayInModal}
    content={<span>{children}</span>}
  />
);
